import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import { useEffect, useState } from 'react'

import { mixOther } from 'api/mixOther'

const SlickSlider = Slider as unknown as React.ComponentType<any>;

type Item = {
    id: string;
    image: string;
    link: string;
}

type Home = {
    meta_title: string;
    meta_description: string;
    meta_keywords: string;
    list_slider_khuyenmai: Item[];
};

const banners = [
    {
        href: "/promotion/9ewlf-sieu-deal-cuoi-nam",
        img: "/theme/img_202574710bcbcc5b1d9faaeae7e9acdb.png",
    },
    {
        href: "/promotion/3q43g-clearance-near-expire--mien-nam",
        img: "/theme/img_2025b57980eb97576965f5e8cbb9f99e.png",
    },
];

export default function SliderTop() {

    const [home, setHome] = useState<Home | null>(null)
    
        useEffect(() => {
            const loadOther = async () => {
                const res = await mixOther("sshome","vi")
                 if (!res?.status || !res.data?.json) {
                    return;
                }
    
                try {
                    const parsed = JSON.parse(res.data.json);
                    setHome((prev) => ({ ...prev, ...parsed }));
                } catch (error) {
                    console.error("Failed to parse setting JSON:", error);
                }
            };
    
            loadOther();
        }, [])
    
    const settings = {
        dots: true,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 3000,
        arrows: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        className: "slick-slider",
        dotsClass: "slick-dots slick-thumb",
    };

    return (
        <div className="styles_wrapper_slider__ArKGC">
            <SlickSlider {...settings}>
                {home?.list_slider_khuyenmai && home.list_slider_khuyenmai.length > 0 && home.list_slider_khuyenmai.map((item, index) => (
                    <div key={index}>
                        <a href={item.link} title="">
                            <div className="styles_banner_bg_img__JnBFU">
                                <div>
                                    <span style={{ position: "absolute", inset: 0 }}>
                                        <img
                                            src={item.image}
                                            style={{
                                                position: "absolute",
                                                inset: 0,
                                                width: "100%",
                                                height: "auto",
                                                objectFit: "contain",
                                            }}
                                        />
                                    </span>
                                </div>
                            </div>
                        </a>
                    </div>
                ))}
            </SlickSlider>
        </div>
    );
}
